module.exports = __webpack_public_path__ + "static/media/KALM-BNB.6b309740.svg";